import React from "react";
import { useTranslation } from "react-i18next";
import capitalizeFirstLetter from "./capitalizeFirstLetter";

/* eslint-disable prefer-template */
const ConvertNumberToWords = ({
  value,
  display,
}: {
  value: number;
  display: "initial" | "uppercase" | "lowercase";
}) => {
  const { t } = useTranslation("new_sign_up");
  const ones = [
    "",
    t("one"),
    t("two"),
    t("three"),
    t("four"),
    t("five"),
    t("six"),
    t("seven"),
    t("eight"),
    t("nine"),
    t("ten"),
    t("eleven"),
    t("twelve"),
    t("thirteen"),
    t("fourteen"),
    t("fifteen"),
    t("sixteen"),
    t("seventeen"),
    t("eighteen"),
    t("nineteen"),
  ];
  const tens = [
    "",
    "",
    t("twenty"),
    t("thirty"),
    t("forty"),
    t("fifty"),
    t("sixty"),
    t("seventy"),
    t("eighty"),
    t("ninety"),
  ];

  const numberToWordsConverter = (num: number): string => {
    const newValue = Math.floor(num);
    const numString = newValue.toString();

    if (newValue < 0) throw new Error(t("Negative numbers are not supported."));

    if (newValue === 0) return t("zero");

    // the case of 1 - 20
    if (newValue < 20) {
      return ones[newValue];
    }

    if (numString.length === 2) {
      return tens[Number(numString[0])] + " " + ones[Number(numString[1])];
    }

    // 100 and more
    if (numString.length === 3) {
      if (numString[1] === "0" && numString[2] === "0")
        return ones[Number(numString[0])] + " " + t("hundred");
      return (
        ones[Number(numString[0])] +
        +" " +
        t("hundred") +
        " " +
        t("and") +
        " " +
        numberToWordsConverter(+(numString[1] + numString[2]))
      );
    }

    if (numString.length === 4) {
      const end = +(numString[1] + numString[2] + numString[3]);
      if (end === 0) return ones[Number(numString[0])] + " " + t("thousand");
      if (end < 100)
        return (
          ones[Number(numString[0])] +
          +" " +
          t("thousand") +
          " " +
          t("and") +
          " " +
          numberToWordsConverter(end)
        );
      return (
        ones[Number(numString[0])] +
        " " +
        t("thousand") +
        numberToWordsConverter(end)
      );
    }
    return "";
  };

  const renderResult = () => {
    switch (display) {
      case "initial":
        return capitalizeFirstLetter(numberToWordsConverter(value));
      case "uppercase":
        return numberToWordsConverter(value).toUpperCase();
      case "lowercase":
        return numberToWordsConverter(value).toLowerCase();
      default:
        return "";
    }
  };
  return <span>{renderResult()}</span>;
};

export default ConvertNumberToWords;
